import { useQuery } from "react-query";
import { getInterventionHistory } from "api/customers";
import { GET_INTERVENTION_HISTORY } from "@constants/reactQueryKeys";

const EMPTY_INTERVENTION_HISTORY: unknown[] = [];

const useGetInterventionHistory = (clientId: number | null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_INTERVENTION_HISTORY, clientId],
    () => getInterventionHistory(clientId!),
    { enabled: Boolean(clientId) }
  );

  return {
    interventionHistory: data?.data ?? EMPTY_INTERVENTION_HISTORY,
    isInterventionHistoryLoading: isLoading,
    refetchInterventionHistory: refetch,
  };
};

export default useGetInterventionHistory;
